import { render, staticRenderFns } from "./ModalCriarEditarEspecialidade.vue?vue&type=template&id=a9a1c38e"
import script from "./ModalCriarEditarEspecialidade.vue?vue&type=script&lang=ts"
export * from "./ModalCriarEditarEspecialidade.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports